import React from "react"
import styled from "styled-components"
import { SectionWrapper } from "../../components/common/wrappers/Wrappers"
import { color, transition } from "../../configs/utilities"
import { SectionTitle } from "../../components/common/typography/Typography"

import { Link } from "gatsby"

const AreaServedSection = ({ areas }) => {
  return (
    <Wrapper>
      <SectionWrapper paddingSm="30px 20px" paddingXl="40px 100px">
        <SectionTitle>Additional Area Served</SectionTitle>
        <AreasWrapper>
          {areas.map((item, index) => {
            return (
              <SingleArea key={index}>
                <Link to={`/movers/${item.slug}/${item.city_slug}`}>
                  {item.city_name}
                </Link>
                <span>,</span>
              </SingleArea>
            )
          })}
        </AreasWrapper>
      </SectionWrapper>
    </Wrapper>
  )
}

export default AreaServedSection

const Wrapper = styled.div``

const AreasWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
`

const SingleArea = styled.div`
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: 0;
  &:last-child {
    span {
      display: none;
    }
  }
  a {
    color: ${color.gray};
    transition: ${transition.default};

    &:hover {
      color: ${color.link} !important;
    }
  }
`
